export const USER = 'User';
export const DATE = 'Date';
export const AMOUNT = 'Amount';
export const DESCRIPTION = 'Description';
export const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
	'July', 'August', 'September', 'October', 'November', 'December'
];